import React, { useState } from 'react';
import './Carousel.scss';

const Carousel = ({ items }) => {
  const [firstItemIndex, setFirstItemIndex] = useState(0);

  if (!items.length) return null;

  const shownItems = Array.from({ length: Math.min(3, items.length) }, (_, offset) =>
    items[(firstItemIndex + offset) % items.length]
  );

  const changeSlide = (direction) => {
    setFirstItemIndex((index) => (index + direction + items.length) % items.length);
  };

  return (
    <section className="carousel" aria-label="Opinie klientów">
      <div className="carousel-track">
        {shownItems.map((item, offset) => (
          <div className="carousel-item" key={`${firstItemIndex}-${offset}`}>
            {item.content}
          </div>
        ))}
      </div>
      <button
        className="carousel-button left"
        type="button"
        aria-label="Poprzednia opinia"
        onClick={() => changeSlide(-1)}
      >
        ◀
      </button>
      <button
        className="carousel-button right"
        type="button"
        aria-label="Następna opinia"
        onClick={() => changeSlide(1)}
      >
        ▶
      </button>
    </section>
  );
};

export default Carousel;
